import React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import { MDXProvider } from '@mdx-js/react';
import InlineCTA from './src/components/inline-cta';
import NewsletterCapture from './src/components/newsletter-capture';
import CTASection from './src/components/cta-section';
import BlogVideoPlayer from './src/components/blog-video-player';
import CourseVideoPlayer from './src/components/course-video-player';
import ModuleQuiz from './src/components/module-quiz';
import ProcessFlow from './src/components/diagrams/ProcessFlow';
import BarChart from './src/components/diagrams/BarChart';
import HeatMap from './src/components/diagrams/HeatMap';
import HierarchyMap from './src/components/diagrams/HierarchyMap';
import TwoByTwoMatrix from './src/components/diagrams/TwoByTwoMatrix';
import LineChart from './src/components/diagrams/LineChart';
import ScoreCard from './src/components/diagrams/ScoreCard';
import SipocDiagram from './src/components/diagrams/SipocDiagram';
import PhasedTimeline from './src/components/diagrams/PhasedTimeline';
import RadarDiagram from './src/components/diagrams/RadarDiagram';
import FishboneDiagram from './src/components/diagrams/FishboneDiagram';

// bpmn-js styles for BPMN modeler
import 'bpmn-js/dist/assets/diagram-js.css';
import 'bpmn-js/dist/assets/bpmn-js.css';
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css';

// Table wrapper component to fix overflow/cutoff on wide tables
const TableWrapper: React.FC<React.TableHTMLAttributes<HTMLTableElement>> = (props) => (
  <div className="table-wrapper">
    <table {...props} />
  </div>
);

const components = {
  InlineCTA,
  NewsletterCapture,
  CTASection,
  BlogVideoPlayer,
  CourseVideoPlayer,
  ModuleQuiz,
  ProcessFlow,
  BarChart,
  HeatMap,
  HierarchyMap,
  TwoByTwoMatrix,
  LineChart,
  ScoreCard,
  SipocDiagram,
  PhasedTimeline,
  RadarDiagram,
  FishboneDiagram,
  table: TableWrapper,
};

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
  return <MDXProvider components={components}>{element}</MDXProvider>;
};

